var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"change-customer-info"}},[_c('b-card',{attrs:{"header-tag":"header"}},[_c('change-customer-data')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }